import memoize from "memoize-one";
import moment from "moment";
import deepEqual from "lodash/isEqual";

// Order the destination by eta
export default memoize(destinations => {
  return destinations.sort((a, b) =>
    moment(a.eta, "DD-MM-YYYY HH-mm").diff(moment(b.eta, "DD-MM-YYYY HH-mm"))
  );
}, deepEqual);